import { useEffect, useState } from 'react';
import { Form, Input, Select, Switch, Button, Alert } from '@/shared/ui/primitives';
import { useTranslation } from 'react-i18next';

const TYPES = ['STRING', 'NUMBER', 'BOOLEAN', 'JSON'];

export default function SystemSettingForm({ initialData, onSubmit, isLoading }: any) {
  const [form] = Form.useForm();
  const { t } = useTranslation();
  const [formType, setFormType] = useState(initialData?.type || 'STRING');

  useEffect(() => {
    if (initialData) {
      form.setFieldsValue({ key: initialData.key || '', value: initialData.value || '', type: initialData.type || 'STRING', description: initialData.description || '', editableByAdmin: initialData.editableByAdmin ?? true });
      setFormType(initialData.type || 'STRING');
    }
  }, [initialData, form]);

  const handleFinish = (values: any) => {
    if (values.type === 'JSON' && values.value) { try { JSON.parse(values.value); } catch { return; } }
    onSubmit(values);
  };

  const renderValueInput = () => {
    if (formType === 'BOOLEAN') return <Select options={[{ label: 'True', value: 'true' }, { label: 'False', value: 'false' }]} />;
    if (formType === 'JSON') return <Input.TextArea rows={6} placeholder='{"example": "value"}' style={{ fontFamily: 'monospace' }} />;
    return <Input type={formType === 'NUMBER' ? 'number' : 'text'} />;
  };

  return (
    <Form form={form} layout="vertical" onFinish={handleFinish} initialValues={{ key: '', value: '', type: 'STRING', description: '', editableByAdmin: true }} style={{ maxWidth: 560 }}>
      <Form.Item label={t('systemSettings.key')} name="key" rules={[{ required: true }]} tooltip={t('systemSettings.keyHint')}>
        <Input disabled={!!initialData} placeholder="e.g. maintenance_mode" />
      </Form.Item>
      <Form.Item label={t('systemSettings.type')} name="type" rules={[{ required: true }]}>
        <Select options={TYPES.map((ty) => ({ label: ty, value: ty }))} onChange={(v) => setFormType(v)} />
      </Form.Item>
      <Form.Item label={t('systemSettings.value')} name="value">{renderValueInput()}</Form.Item>
      <Form.Item label={t('systemSettings.description')} name="description">
        <Input.TextArea rows={3} placeholder={t('systemSettings.descriptionPlaceholder')} />
      </Form.Item>
      <Form.Item label={t('systemSettings.editable')} name="editableByAdmin" valuePropName="checked"><Switch /></Form.Item>
      <Form.Item><Button type="primary" htmlType="submit" loading={isLoading}>{t('common.save')}</Button></Form.Item>
    </Form>
  );
}
